export const donwloadFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename, 'hidden');
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};
